import { Flex, Text } from '@chakra-ui/react';
import { CustomInfoIcon } from '../../../theme/icons/CustomInfoIcon';

export const EventDetailsBannerContent = () => (
  <Text fontSize="14px" color="rgba(0, 0, 0, 0.8)">
    Event details set per pass — pass creation currently API only
  </Text>
);

const EventDetailsBanner = () => (
  <Flex
    align="center"
    gap={3}
    mt={3}
    px="14px"
    py="8px"
    bg="rgba(0, 155, 214, 0.1)"
    borderRadius="5px"
  >
    <CustomInfoIcon color="#009BD6" boxSize="21px" flexShrink={0} />
    <EventDetailsBannerContent />
  </Flex>
);

export default EventDetailsBanner;
